import React from 'react';
import styled from 'styled-components';
import { useInView } from '../../hooks/useInView';

const Wrapper = styled.div<{ $visible: boolean; $delay?: number }>`
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? '0' : '30px')});
  transition: opacity 0.7s ease, transform 0.7s ease;
  transition-delay: ${({ $delay }) => ($delay ?? 0) * 0.15}s;
`;

interface AnimatedSectionProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

export function AnimatedSection({ children, delay, className }: AnimatedSectionProps) {
  const { ref, isInView } = useInView({ threshold: 0.1 });

  return (
    <Wrapper ref={ref} $visible={isInView} $delay={delay} className={className}>
      {children}
    </Wrapper>
  );
}
